/* ==========================================================================
   CASEMIRA · LE ⓘ DE TRANSPARENCE DU BADGE D'AVIS
   Fichier : assets/casemira-badge-avis.js · 07/09/2026, chantier 7, lot v8.

   CE QU'IL FAIT, ET RIEN D'AUTRE. Il ouvre et ferme la bulle de transparence
   du badge d'avis de la bande de réassurance, sur la page d'accueil comme au
   pied de toutes les autres pages. Le comportement est celui de la bannière
   (`sections/casemira-hero-collection.liquid`, § avis) : ouverture AU CLIC et
   seulement au clic, jamais au survol, fermeture par un second clic, par un
   clic ailleurs et par Échap.

   POURQUOI UN FICHIER ET PAS UNE LIGNE DANS CHACUN DES DEUX SCRIPTS. La bande
   vit sur deux feuilles distinctes et dans deux contextes distincts, mais le
   comportement, lui, est le même : le dupliquer, c'est accepter qu'un jour il
   diverge. Le fichier pèse moins d'un kilo-octet, il est `defer`, et il ne
   s'exécute qu'une fois même si le badge était rendu deux fois sur la page.

   SANS JAVASCRIPT, le badge reste un lien vers la page des avis et la bulle
   n'est simplement jamais montrée : rien n'est caché derrière une promesse de
   script (la feuille laisse la bulle invisible et non focalisable par défaut,
   et le bouton, lui, n'a d'utilité que si ce fichier arrive).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cmbaArme) return;
  window.__cmbaArme = true;

  function fermer(tete) {
    tete.classList.remove('est-ouvert');
    var b = tete.querySelector('[data-cmba-i]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function tout(sauf) {
    var l = document.querySelectorAll('[data-cmba].est-ouvert');
    for (var i = 0; i < l.length; i++) if (l[i] !== sauf) fermer(l[i]);
  }

  document.addEventListener('click', function (e) {
    var bouton = e.target.closest ? e.target.closest('[data-cmba-i]') : null;
    if (bouton) {
      var tete = bouton.closest('[data-cmba]');
      if (!tete) return;
      e.preventDefault();
      var ouvert = tete.classList.contains('est-ouvert');
      tout(tete);
      if (ouvert) { fermer(tete); return; }
      tete.classList.add('est-ouvert');
      bouton.setAttribute('aria-expanded', 'true');
      return;
    }
    /* Un clic DANS la bulle ne la ferme pas : elle porte un lien. */
    if (e.target.closest && e.target.closest('[data-cmba-bulle]')) return;
    tout(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var ouvert = document.querySelector('[data-cmba].est-ouvert');
    if (!ouvert) return;
    var b = ouvert.querySelector('[data-cmba-i]');
    fermer(ouvert);
    if (b) b.focus();
  });
})();
